import { Box } from '@wix/design-system';
import { ChevronDownSmall, ChevronRightSmall, ChevronUpSmall } from '@wix/wix-ui-icons-common';
import React, { useMemo } from 'react';
import { wdsThemeColors } from '../../../../utils/wds-theme-colors';
export const ArrowIcon = /*#__PURE__*/React.memo(_ref => {
  let {
    variant,
    isExpanded,
    disabled = false
  } = _ref;
  const arrowIcon = useMemo(() => {
    if (variant === 'button') {
      return /*#__PURE__*/React.createElement(ChevronRightSmall, null);
    }
    if (variant === 'collapsible') {
      return isExpanded ? /*#__PURE__*/React.createElement(ChevronUpSmall, null) : /*#__PURE__*/React.createElement(ChevronDownSmall, null);
    }
    return null;
  }, [variant, isExpanded]);
  return /*#__PURE__*/React.createElement(Box, {
    color: disabled ? wdsThemeColors.iconDisabled : wdsThemeColors.textPrimary,
    height: "18px",
    verticalAlign: "middle",
    width: "18px"
  }, arrowIcon);
});
//# sourceMappingURL=arrow-icon.js.map